module.exports = __webpack_public_path__ + "assets/plus.5a2c48d9.svg";